import React from 'react'
import { useState } from 'react'
import { useFormik } from 'formik'
import ReactLoading from 'react-loading'
import axios from 'axios'
import toast from 'react-hot-toast'
import Toast from '../Toaster';
import { CreateVisitationSchema } from '../../schemas';
import mode from '../Mode';
import Overlay from '../overlay';
import { useSelector } from 'react-redux'

const Visitation = () =>{
    const [isLoading, setIsLoading] = useState(false);
    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/': 'http://127.0.0.1:8000/';
    const token = useSelector((state)=>state.auth.token)

    const config = {
        headers: {
            'Content-Type':'application/json'
        }
    }

    if(token){
        config.headers['Authorization'] = `Token ${token}`;
    }

    const onSubmit = () =>{
        setIsLoading(true)
        axios.post(baseurl+"nurturing/visitation/", config, values).then((resp)=>{
            setIsLoading(false)
            //console.log(resp)
            toast.success("Visitation successfully submitted", 3000)
        }).catch((err)=>{
            toast.error("An error occurred", 3000)
            //console.log(err)
            setIsLoading(false)
        })
        
    }
    const {values, errors, touched, handleBlur, handleChange, handleSubmit} = useFormik({
        initialValues: {
            name: '',
            contact: '',
        },
        validationSchema: CreateVisitationSchema,
        onSubmit
    })
    return (
        <div className="App">
            <Overlay/>
            <Toast/>
            <div className="main-content">
            <br/>
            <br/>
            <br/>
            <div className='container content-section'>
            <div className="row d-flex flex-column align-items-center justify-content-center m-auto" style={{backgroundColor: "transparent", border: 'none'}}>
                <div className="content-section content col-md-5 m-auto" style={{backgroundColor: "white"}}>
                    <form method="POST" className='forms'>
                        <fieldset>
                            <legend className="mb-4" style={{color:'#228bdf'}}>Request Visitation</legend>                              
                                <div className="row">
                                    <div className="form-group col-md-12">
                                        <label htmlFor="inputEmail4" className='form-control-lg'>First Name</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name='name'
                                            value = {values.name}
                                            onChange = {handleChange}
                                            onBlur = {handleBlur}
                                            placeholder="Full Name"
                                            style = {errors.name && touched.name ? {borderColor:"#fc8181"}:{}}/>
                                            { errors.name && touched.name && <p className='error'>{errors.name}</p>}
                                    </div>
                                    <div className="form-group col-md-12">
                                        <label htmlFor="inputPassword4" className='form-control-lg'>Contact Phone</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name='contact'
                                            value = {values.contact}
                                            onChange = {handleChange}
                                            onBlur = {handleBlur}
                                            placeholder="Phone Number"
                                            style = {errors.contact && touched.contact ? {borderColor:"#fc8181"}:{}}/>
                                            { errors.contact && touched.contact && <p className='error'>{errors.contact}</p>}
                                    </div>
                                </div>
                                
                        </fieldset>
                        <div className="form-group" style={{margin: '6px'}}>
                            <button className="btn btn-outline-info" type="submit" disabled={isLoading} style={{borderRadius: '0.5rem'}} onClick={handleSubmit}> {isLoading ? <ReactLoading type="spin" color="rgb(11, 43, 66)" height={25} width={25} />: "Submit"}</button>
                        </div>
                    </form>
                </div>
            </div>
            <br/>
        </div>  
                
            </div>
        </div>
    )
}

export default Visitation